import { createStore, select, withProps } from '@ngneat/elf';
import { DisclosureDates } from '../../models/disclosure-dates.model';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DisclosureDatesRepository {
  private _store = createStore(
    { name: 'disclosureDates' },
    withProps<DisclosureDates>({
      disclosureDeadline: null,
      selfDisclosureDeadline: null,
      initialDisclosuresRequested: null,
    }),
  );

  dates$ = this._store.pipe(select((state) => state));

  stateChange(state: Partial<DisclosureDates>): void {
    this._store.update((old) => ({ ...old, ...state }));
  }
}
